module.exports = __webpack_public_path__ + "static/media/nofun-logo-title.2f526be3.png";